import { ApplicationStatus } from "../../mirage/core/enums";

export const VerifyCommentsDisabled = (statusToVerify: string | null | undefined) => {
    const forbiddenStatuses = [ApplicationStatus.Determined, ApplicationStatus.Withdrawn, ApplicationStatus.Invalid];
    const commentsDisabled = forbiddenStatuses.includes(statusToVerify as ApplicationStatus);
    return commentsDisabled;
};
